// Route chunk prefetch map.
// Hover/focus/touchstart on a sidebar link calls prefetchRoute(path), which
// triggers the dynamic import(). Webpack dedupes — the same module requested
// here and via React.lazy in App.js resolves to a single chunk.
//
// Only lazy routes are listed here; eager routes (Login, Dashboard, Tables,
// Orders, Kitchen, QRMenu, POSDisplay) are already in the main bundle.

const routePrefetchMap = {
  '/menu-management':     () => import('../pages/MenuManagement'),
  '/stock':               () => import('../pages/Stock'),
  '/recipes':             () => import('../pages/Recipes'),
  '/payments':            () => import('../pages/Payments'),
  '/users':               () => import('../pages/Users'),
  '/pricing':             () => import('../pages/Pricing'),
  '/checkout':            () => import('../pages/Checkout'),
  '/subscription/result': () => import('../pages/PaymentResult'),
  '/my-subscription':     () => import('../pages/MySubscription'),
  '/waiter-stats':        () => import('../pages/WaiterStats'),
  '/reports':             () => import('../pages/Reports'),
  '/settings':            () => import('../pages/Settings'),
  '/superadmin':          () => import('../pages/superadmin/SuperDashboard'),
  '/superadmin/restaurants':   () => import('../pages/superadmin/Restaurants'),
  '/superadmin/plans':         () => import('../pages/superadmin/SaasPlans'),
  '/superadmin/subscriptions': () => import('../pages/superadmin/SaasSubscriptions'),
  '/chain':               () => import('../pages/chain/ChainDashboard'),
  '/chain/branches':      () => import('../pages/chain/ChainBranches'),
  '/chain/reports':       () => import('../pages/chain/ChainReports'),
  '/chain/analytics':     () => import('../pages/chain/ChainReports'),
  '/chain/menu':          () => import('../pages/chain/ChainMenu'),
  '/chain/staff':         () => import('../pages/chain/ChainStaff'),
  '/promo-codes':         () => import('../pages/PromoCodes'),
  '/gift-vouchers':       () => import('../pages/GiftVouchers'),
  '/customers':           () => import('../pages/Customers'),
  '/delivery-orders':     () => import('../pages/DeliveryOrders'),
  '/platform-management': () => import('../pages/PlatformManagement'),
  '/pos':                 () => import('../pages/POSTerminal'),
  '/printers':            () => import('../pages/PrinterManagement'),
  '/forgot-password':     () => import('../pages/ForgotPassword'),
  '/reset-password':      () => import('../pages/ResetPassword'),
  '/reservations':        () => import('../pages/Reservations'),
  '/shifts':              () => import('../pages/Shifts'),
  '/gdpr':                () => import('../pages/GDPR'),
  '/white-label':         () => import('../pages/WhiteLabel'),
  '/webhooks':            () => import('../pages/Webhooks'),
  '/audit-logs':          () => import('../pages/AuditLogs'),
  '/security':            () => import('../pages/Security'),
  '/trash':               () => import('../pages/Trash'),
  '/tax-groups':          () => import('../pages/TaxGroups'),
  '/feature-flags':       () => import('../pages/FeatureFlags'),
  '/notifications':       () => import('../pages/Notifications'),
  '/onboarding':          () => import('../pages/Onboarding'),
  '/hr':                 () => import('../pages/HR'),
};

// Track which paths have already been requested so we don't spam logs or the
// network tab. import() itself is idempotent in webpack, but this skips the
// function call entirely.
const prefetched = new Set();

export function prefetchRoute(path) {
  if (!path || prefetched.has(path)) return;
  const fn = routePrefetchMap[path];
  if (!fn) return;
  prefetched.add(path);
  fn().catch(() => {
    // Network error or chunk 404 (deploy mid-session) — clear flag so a
    // later click still attempts the navigation, and React.lazy will handle
    // the retry + ErrorBoundary fallback.
    prefetched.delete(path);
  });
}
